import '@sorrem/ui/styles/global.css';
import './ui/styles/cursors.scss';
import './ui/styles/hud-type.scss';
import './ui/styles/game-canvas.scss';
import './ui/styles/screen-background.scss';
import { createRoot } from 'react-dom/client';
import { StrictMode } from 'react';
import { Provider } from 'react-redux';
import { AppRoutes } from '@sorrem-client/ui/features/AppRoutes';
import { ConfirmModalProvider, ErrorBoundary, ItemIconBodyProvider, ItemTransferProvider, PopoverProvider, Toast, ToastProvider } from './ui/components';
import { store } from './ui/store';
import { preloadCursorImages } from './ui/styles/cursor-images';
import { seedAssetManifest } from './ui/assets/asset-manifest-seed';
import { installCrashReporting } from './ui/telemetry';
import { getGameSession } from './game/game-session-store';

installCrashReporting(() => {
    const session = getGameSession();
    if (session === undefined) {
        return {};
    }
    const telemetry = session.bridge.getState().telemetry;
    return {
        crucibleId: session.crucibleId,
        // No frames yet means the run never drew: leave timing out rather than report zeros.
        ...(telemetry.totalFrameCount > 0 ? {
            frameTiming: {
                fps: telemetry.fps,
                averageFrameTimeMs: telemetry.averageFrameTimeMs,
                averageRenderTimeMs: telemetry.averageRenderTimeMs,
                maxFrameTimeMs: telemetry.maxFrameTimeMs,
                catchUpFrameCount: telemetry.catchUpFrameCount,
            },
        } : {}),
    };
});
preloadCursorImages();
// Versioned asset URLs from the first render (#285).
seedAssetManifest();

const uiRoot = document.getElementById('ui-root');
if (uiRoot !== null) {
    createRoot(uiRoot).render(
        <StrictMode>
            <ErrorBoundary label="Sorrem">
                <Provider store={store}>
                    <ConfirmModalProvider>
                        <ToastProvider>
                            <ItemTransferProvider>
                                <PopoverProvider>
                                    <ItemIconBodyProvider>
                                        <Toast />
                                        <AppRoutes />
                                    </ItemIconBodyProvider>
                                </PopoverProvider>
                            </ItemTransferProvider>
                        </ToastProvider>
                    </ConfirmModalProvider>
                </Provider>
            </ErrorBoundary>
        </StrictMode>);
}
